import styled from "styled-components";

export const StyledRowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  align-items: start;
`;

export const StyledBodyInternalGrade = styled.div`
  & > div:not(:last-child) {
    width: auto;
  }

  & .internal-grade-bordered-container {
    margin-bottom: 40px;
  }
`;
